export default "__VITE_ASSET__CD0FnBFY__";